import React from 'react'

import Navbar from './Navbar'
import { Route, Routes } from 'react-router'
import { Home, NotFound404 } from '../../views'
import { PrivateRoute } from '@climate/components'


export default function StackedLayout() {
  return (
    <div className="min-h-screen">
      <Navbar/>
      <Routes>
        <Route path="home" element={<PrivateRoute component={Home} scope="iam" />} />
        <Route path="404" element={<NotFound404 />} />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </div>
  )
}
